(() => {
  if (window.__xoServiceContentSmoothScrollInitialized) return;

  window.__xoServiceContentSmoothScrollInitialized = true;

  const selector = '[data-service-scroll-link]';

  const scrollToTarget = (hash) => {
    if (!hash || !hash.startsWith('#')) return false;

    const target = document.querySelector(hash);

    if (!target) return false;

    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });

    if (window.history?.replaceState) {
      window.history.replaceState(null, '', hash);
    }

    return true;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(selector);

    if (!trigger) return;

    const href = trigger.getAttribute('href');

    if (!href || !href.startsWith('#')) return;

    if (scrollToTarget(href)) {
      event.preventDefault();
    }
  });
})();
